import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PopConfirmComponent } from '../../core/pop-confirm/pop-confirm.component';

import { NgForm } from '@angular/forms';
import { ProductCombo } from 'src/app/models/ProductCombo';
import { ProductComboService } from 'src/app/service/product-combo.service';

@Component({
  selector: 'app-product-combo-form',
  templateUrl: './product-combo-form.component.html',
  styleUrls: ['./product-combo-form.component.scss'],
})
export class ProductComboFormComponent implements OnInit {
  @Input() currentItem: ProductCombo;
  @Output() ShowForm = new EventEmitter<boolean>();

  @Output() submitEmitterCanCloseChildForm = new EventEmitter<any>(); //event permettant d'indiquer que l'enfant (ici) veut se fermer
  @Output() submitEmitterChildHaveChanges = new EventEmitter<any>(); //event permettant d'indiquer que l'enfant (ici) a des changemenets
  @Output() submitEmitterForceRefresh = new EventEmitter<any>();

  @ViewChild(NgForm) myform!: NgForm; //permet d'accéder ici (TS) au FORM fabriqué FrontEnd, nommé MyForm.

  titre: string;
  NomEntiteCourante: string = 'Combo de produits';
  IsChangesPublished: boolean = false;

  constructor(private dialog: MatDialog, private snack: MatSnackBar, private myMainService: ProductComboService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    //on va essayer de ramasser le ID du projet par la route, si possible (en cas de pop-up, entre autre.. pas obligé)
    let MyPackageTypesIdByParam = this.route.snapshot.paramMap.get('id');
    //si on recoit un ID par la route, on va instancier le composant actuel
    if (MyPackageTypesIdByParam) {
      this.currentItem = new ProductCombo();
      this.currentItem.id = +MyPackageTypesIdByParam;
    }
  }

  //méthode permettant de rafraichir les données actuelle
  refreshInterface() {
    //var id = this.route.snapshot.paramMap.get('id');
    if (this.currentItem) {
      // EDIT
      this.titre = 'Modifier un Taux';
      // fetch project data
      this.myMainService.get(this.currentItem.id).subscribe((jsonData) => {
        this.currentItem = jsonData;
      });
    } else {
      // ADD
      this.currentItem = new ProductCombo();
      this.titre = 'Ajouter un nouveau combo';
    }
  }

  //Evenement de sauvegarde...on encapsule pour gérer si on doit faire un pop-up ou non
  OnSauvegardeClick() {
    //si le formulaire est invalide [des champs required qui sont vides], on va demander à l'usager de confirmer
    if (this.myform.valid === false) {
      // pop dialog
      const dialogRef = this.dialog.open(PopConfirmComponent, {
        data: {
          titre: 'Formulaire avec champ invalide',
          texte: 'Attention!  Certains champs obligatoires ne semblent pas avoir été remplit. <br/><br/>Désirez-vous enregistrer QUAND MÊME?',
          affirmativeActionName: 'Oui, enregistrer quand même',
          affirmativeActionColor: 'primary',

          dismissiveActionName: 'Non, revenir en arrière',
          dismissiveActionColor: 'warn',
        },
      });
      // after close dialog
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.sauvegarder();
        }
      });
    } else {
      //si le modèle était valide dès le début, on enregistre.
      this.sauvegarder();
    }
  }

  //méthode pour enregistrer dans la bd
  sauvegarder() {
    let action = 'sauvegardé';
    //si le projet a un ID, c'estun UPDATe...

    if (this.currentItem.id === undefined || this.currentItem.id === null) this.currentItem.id = -1;

    if (this.currentItem.id > 0) {
      // EDIT
      this.myMainService.update(this.currentItem).subscribe((jsonData) => {
        //on ferme le FORM
        this.cacherForm(true);
        //pop-up...
        this.snack.open('Le combo a été ' + action + '.', '', { duration: 3000 });
        this.IsChangesPublished = true;
      });
    } else {
      // ADD
      this.myMainService.create(this.currentItem).subscribe((jsonData) => {
        this.currentItem = jsonData;
        action = 'ajouté';

        //on ferme le FORM
        this.cacherForm(true);
        //pop-up...
        this.snack.open('Le combo a été ' + action + '.', '', { duration: 3000 });
        this.IsChangesPublished = true;
      });
    }
  }

  detruire() {
    // pop dialog
    /*const dialogRef = this.dialog.open(PopConfirmComponent, {
     data: {
       titre: 'Supprimer la station',
       texte: 'Êtes-vous sûr de vouloir supprimer ce type de paquet?',
       affirmativeActionName:'Supprimer',
       affirmativeActionColor:'warn',

       dismissiveActionName:'Annuler',
       dismissiveActionColor:'',
     },
   });
   // after close dialog
   dialogRef.afterClosed().subscribe((result) => {
     if (result === true) {
       //si on répond OUI, (affirmative)  on procède à la suppression
        this.myMainService.delete(this.currentItem.id).subscribe((jsonData) => {
          this.cacherForm(true);
          this.snack.open('Le type de paquet a été détruit.', '', { duration: 3000 });
          this.IsChangesPublished = true;
       });
     }
   });*/
  }

  annuler() {
    this.cacherForm();
  }

  cacherForm(param_ForceParentRefresh: boolean = false): void {
    this.submitEmitterChildHaveChanges.emit(false); //on raise le event indiquant si l'enfant a des changements en cours (false, ici)
    this.submitEmitterCanCloseChildForm.emit(true); //on raise le Event permettant de demander de se faire fermer
    this.submitEmitterForceRefresh.emit(param_ForceParentRefresh);
  }

  validateForm(parmaForm: any) {
    myForm: parmaForm;
  }

  //Détecte N'IMPORTE quel changement sur mon composant
  ngDoCheck(changes: any) {
    let test = changes;

    if (this.myform?.pristine === false && this.IsChangesPublished === false) {
      this.IsChangesPublished = true;
      this.submitEmitterChildHaveChanges.emit(true);
    }
  }

  //ne détecte QUE les changements sur les @input values
  ngOnChanges() {
    this.refreshInterface();
  }
}
